import * as msTeams from '@microsoft/teams-js';

export const checkAppIsRunningInTeams = (): boolean => {
  const microsoftTeamsLib = msTeams || (window as any).microsoftTeams;
  const isTeamsApp = new URLSearchParams(window.location.search).get('isTA');

  if (!microsoftTeamsLib) return false;

  if (
    (window.parent === window.self && (window as any).nativeInterface) ||
    window.name === 'embedded-page-container' ||
    window.name === 'extension-tab-frame'
  ) {
    return true;
  }

  if (microsoftTeamsLib) {
    if (isTeamsApp === 'true') {
      sessionStorage.setItem('isTA', 'true');
      return true;
    }
    if (sessionStorage.getItem('isTA') === 'true') return true;
  }

  return false;
};

export const isAppRunningInTeams = checkAppIsRunningInTeams();


